import { useState } from "react";
import { Link } from "react-router-dom";

const ShopProduct = ({ products }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 6;
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const totalPages = Math.ceil(products.length / perPage);
  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;
  const currentProducts = products.slice(indexOfFirst, indexOfLast);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  // --- Inline Styles ---
  const gridContainerStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: "20px",
  };

  const cardStyle = {
    background: "#fff",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0, 31, 92, 0.25)",
    overflow: "hidden",
    height: "420px",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  };

  const imgHolderStyle = {
    height: "200px",
    overflow: "hidden",
  };

  const imgStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.4s ease",
  };

  const detailsStyle = {
    padding: "15px",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  };

  const titleStyle = {
    fontSize: "18px",
    marginBottom: "8px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  };

  const descStyle = {
    flexGrow: 1,
    color: "#555",
    fontSize: "14px",
    lineHeight: 1.4,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    marginBottom: "10px",
  };

  const buttonContainerStyle = {
    textAlign: "center",
  };

  const buttonStyle = {
    background: "linear-gradient(90deg, #001F5C, #007BFF)",
    color: "#fff",
    border: "none",
    padding: "8px 14px",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background 0.3s ease",
    boxShadow: "0 0 8px rgba(0, 31, 92, 0.5)", // glowing orange shadow for button
  };

  const paginationButtonStyle = {
    background: "linear-gradient(90deg, #001F5C, #007BFF)", // dark → light blue
    color: "#fff",
    border: "none",
    padding: "6px 12px",
    margin: "0 4px",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 0 6px rgba(0, 31, 92, 0.4)",
  };

  const paginationActiveStyle = {
    background: "linear-gradient(90deg, #002B80, #339CFF)", // brighter active gradient
    boxShadow: "0 0 10px rgba(0, 123, 255, 0.6)",
  };

  return (
    <section className="wpo-shop-section">
      <div className="container">
        <div className="row">
          <div className="col col-xs-12">
            <div style={gridContainerStyle}>
              {currentProducts.length > 0 &&
                currentProducts.map((product, pitem) => (
                  <div
                    key={pitem}
                    style={{ ...cardStyle }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow =
                        "0 6px 20px rgba(0, 31, 92, 0.45)"; // deeper blue glow
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 12px rgba(0, 31, 92, 0.25)";
                    }}
                  >
                    <div style={imgHolderStyle}>
                      <img
                        src={`${apiUrl}/storage/` + product.banner}
                        alt=""
                        style={imgStyle}
                      />
                    </div>
                    <div style={detailsStyle}>
                      <h3 style={titleStyle}>
                        <Link
                          onClick={ClickHandler}
                          to={`/product-single/${product.id}`}
                          style={{ color: "#000", textDecoration: "none" }}
                        >
                          {product.title}
                        </Link>
                      </h3>
                      <p
                        style={descStyle}
                        dangerouslySetInnerHTML={{
                          __html:
                            product.description.slice(0, 100) +
                            (product.description.length > 100 ? "..." : ""),
                        }}
                      />
                      <div style={buttonContainerStyle}>
                        <Link
                          onClick={ClickHandler}
                          to={`/product-single/${product.id}`}
                        >
                          <button
                            style={buttonStyle}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background =
                                "linear-gradient(90deg, #002B80, #339CFF)";
                              e.currentTarget.style.boxShadow =
                                "0 0 15px rgba(0, 123, 255, 0.6)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background =
                                "linear-gradient(90deg, #001F5C, #007BFF)";
                              e.currentTarget.style.boxShadow =
                                "0 0 8px rgba(0, 31, 92, 0.5)";
                            }}
                            data-bs-toggle="tooltip"
                            data-bs-html="true"
                            title="Add to Cart"
                          >
                            Product Details
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div
                className="pagination-wrapper pagination-wrapper-center"
                style={{ textAlign: "center", marginTop: "30px" }}
              >
                <ul
                  className="pg-pagination"
                  style={{
                    listStyle: "none",
                    padding: 0,
                    display: "inline-flex",
                  }}
                >
                  <li style={{ margin: "0 5px" }}>
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      aria-label="Previous"
                      style={{
                        ...paginationButtonStyle,
                        opacity: currentPage === 1 ? 0.5 : 1,
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      }}
                      onMouseEnter={(e) => {
                        if (!e.currentTarget.disabled) {
                          e.currentTarget.style.background =
                            "linear-gradient(90deg, #002B80, #339CFF)";
                          e.currentTarget.style.boxShadow =
                            "0 0 10px rgba(0, 123, 255, 0.6)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background =
                          "linear-gradient(90deg, #001F5C, #007BFF)";
                        e.currentTarget.style.boxShadow =
                          "0 0 6px rgba(0, 31, 92, 0.4)";
                      }}
                    >
                      <i className="ti-angle-left"></i>
                    </button>
                  </li>

                  {Array.from({ length: totalPages }, (_, i) => (
                    <li key={i + 1} style={{ margin: "0 5px" }}>
                      <button
                        onClick={() => handlePageChange(i + 1)}
                        style={{
                          ...paginationButtonStyle,
                          ...(currentPage === i + 1
                            ? paginationActiveStyle
                            : {}),
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background =
                            "linear-gradient(90deg, #002B80, #339CFF)";
                          e.currentTarget.style.boxShadow =
                            "0 0 10px rgba(0, 123, 255, 0.6)";
                        }}
                        onMouseLeave={(e) => {
                          if (currentPage === i + 1) {
                            e.currentTarget.style.background =
                              "linear-gradient(90deg, #002B80, #339CFF)";
                          } else {
                            e.currentTarget.style.background =
                              "linear-gradient(90deg, #001F5C, #007BFF)";
                          }
                          e.currentTarget.style.boxShadow =
                            "0 0 6px rgba(0, 31, 92, 0.4)";
                        }}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}

                  <li style={{ margin: "0 5px" }}>
                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      aria-label="Next"
                      style={{
                        ...paginationButtonStyle,
                        opacity: currentPage === totalPages ? 0.5 : 1,
                        cursor:
                          currentPage === totalPages
                            ? "not-allowed"
                            : "pointer",
                      }}
                      onMouseEnter={(e) => {
                        if (!e.currentTarget.disabled) {
                          e.currentTarget.style.background =
                            "linear-gradient(90deg, #002B80, #339CFF)";
                          e.currentTarget.style.boxShadow =
                            "0 0 10px rgba(0, 123, 255, 0.6)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background =
                          "linear-gradient(90deg, #001F5C, #007BFF)";
                        e.currentTarget.style.boxShadow =
                          "0 0 6px rgba(0, 31, 92, 0.4)";
                      }}
                    >
                      <i className="ti-angle-right"></i>
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopProduct;
